import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, ButtonProps } from 'src/components/Button';

export type AlertActionProps = ButtonProps & {
  type?: 'cancel' | 'destructive' | 'regular';
};

export const AlertAction: React.FC<AlertActionProps> = ({ children, ...props }) => (
  <Button variant="tertiary" textStyle={s.text} {...props}>
    {children}
  </Button>
);

const s = StyleSheet.create({
  text: {
    textAlign: 'right',
  },
});
